import { Button } from '@mantine/core';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { FormPair } from './types';
import { canSignKycForm } from './KycFormSignAction.utils';

interface Props {
	form: FormPair;
	onStartSigning: (form: FormPair) => void;
}

/**
 * The row's "Sign" trigger. The modal is mounted at page level via `useKycFormSigning` — a cell's
 * subtree is unmounted whenever the row set changes, which the post-signing refetch causes.
 */
export const KycFormSignAction = ({ form, onStartSigning }: Props) => {
	const tInvestor = useTranslationInvestor();

	if (!canSignKycForm(form)) {
		return null;
	}

	return (
		<Button size="md" variant="subtle" onClick={() => onStartSigning(form)}>
			{tInvestor('investment.join.kyc.kyc_forms.sign_kyc.sign')}
		</Button>
	);
};
